"use client";

import React, { useState } from "react";
import DynamicSwiper from "@/components/common/DynamicSwiper";
import ProductCardV2 from "@/components/product/ProductCardV2";
import { Product } from "@/packages/types/products";
import QuickViewModal from "./QuickViewModal";

interface InterestedProductsProps {
  products: Product[];
}

const InterestedProducts: React.FC<InterestedProductsProps> = ({
  products,
}) => {
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const [isQuickViewOpen, setIsQuickViewOpen] = useState(false);
  const handleQuickView = (product: Product) => {
    setSelectedProduct(product);
    setIsQuickViewOpen(true);
  };

  return (
    <>
      {products.length > 0 && (
        <div className="max-w-7xl mx-auto mt-5 mb-5">
          <h2 className="text-[20px] font-medium  pl-3 mb-4">
            You Might Be Interested In
          </h2>
          <DynamicSwiper
            items={products}
            renderItem={(product) => (
              <div className="px-2">
                <ProductCardV2
                  className="cursor-pointer"
                  product={product}
                  onQuickView={() => handleQuickView(product)}
                />
              </div>
            )}
            slidesPerView={2}
            spaceBetween={10}
            breakpoints={{
              640: { slidesPerView: 2 },
              768: { slidesPerView: 2.5 },
              1024: { slidesPerView: 4 },
              1280: { slidesPerView: 5 },
            }}
          />
        </div>
      )}
      <QuickViewModal
        isOpen={isQuickViewOpen}
        onClose={() => setIsQuickViewOpen(false)}
        slug={selectedProduct?.slug}
      />
    </>
  );
};

export default InterestedProducts;
